import { SessionStorage } from 'quasar';
import { User } from 'src/components/models/models';
import { reactive, toRefs } from 'vue';

const state = reactive({
  user: null as User | null,
});

export function useUser() {
  const { user } = toRefs(state);
  const rawUser = SessionStorage.getItem('user');
  if (typeof rawUser === 'string') {
    try {
      user.value = JSON.parse(rawUser);
    } catch {
      user.value = null;
    }
  } else if (rawUser && typeof rawUser === 'object') {
    user.value = rawUser as User;
  } else {
    user.value = null;
  }

  // Also updates components already using useUser(), e.g. after a late identify
  function setUser(newUser: User) {
    SessionStorage.set('user', newUser);
    state.user = newUser;
  }

  return {
    user,
    setUser,
  };
}
